// 导出主要的 hooks
export { useSiteRedirect } from './useSiteRedirect';
export { useSiteRedirectPopup } from './useSiteRedirectPopup';

// 导出类型定义
export type {
  SiteRedirectData,
  UseSiteRedirectReturn,
  UseSiteRedirectPopupOptions,
  UseSiteRedirectPopupReturn,
} from './types/siteRedirect';

// 导出工具函数
export {
  delay,
  safeAsync,
  getSiteRedirectReferrerInfo,
  getSiteRedirectEnterPageScene,
  getSiteRedirectEncodeUrlWithReferrer,
} from './utils/siteRedirectUtils';
